  import React, { useState, useEffect } from 'react';
  import { useSettings } from '../../../context/settingsContext';
  import { Form, Input, Card, Spin, Button, message } from 'antd';
  import axios from '../../../context/axiosConfig';

  const Limits = () => {
    const { settings, loading } = useSettings();
    const [bankData, setBankData] = useState({
      rachu_obc: '',
      bank_name: ''
    });
    const [isFormChanged, setIsFormChanged] = useState(false);

    useEffect(() => {
      if (settings && !loading) {
        setBankData({
          commistion_bottom_limit: settings.commistion_bottom_limit.msr_settings_value || '',
          commistion_top_limit: settings.commistion_top_limit.msr_settings_value || ''
        });
      }
    }, [settings, loading]);

    useEffect(() => {
      if (settings) {
        const hasChanges = 
          bankData.commistion_bottom_limit !== (settings.commistion_bottom_limit.msr_settings_value || '') ||
          bankData.commistion_top_limit !== (settings.commistion_top_limit.msr_settings_value || '');
        setIsFormChanged(hasChanges);
      }
    }, [bankData, settings]);

    const handleChange = (e) => {
      const { name, value } = e.target;
      let adjustedValue = value;
      if (name === 'commistion_bottom_limit' || name === 'commistion_top_limit') {
        if (value > 100) adjustedValue = 100;
        if (value < 0) adjustedValue = 0;
      }
      setBankData(prev => ({
        ...prev,
        [name]: adjustedValue
      }));
    };

    const handleSubmit = async () => {
      try {
        await axios.post('/settings/update', bankData);
        message.success('Dane bankowe zostały zaktualizowane');
        setIsFormChanged(false);
      } catch (error) {
        message.error('Wystąpił błąd podczas aktualizacji danych');
      }
    };

    if (loading) {
      return <Spin />;
    }

    return (
      <Card>
        <Form layout="vertical">
          <Form.Item label="Dolny limit prowizji z umowy klienta [%]">
            <Input
              name="commistion_bottom_limit"
              value={bankData.commistion_bottom_limit}
              onChange={handleChange}
              type="number"
              max={100}
              min={0}
            />
          </Form.Item>
          <Form.Item label="Górny limit prowizji z umowy klienta [%]">
            <Input
              name="commistion_top_limit"
              value={bankData.commistion_top_limit}
              onChange={handleChange}
              type="number"
              max={100}
              min={0}
            />
          </Form.Item>
          <Form.Item>
            <Button 
              type="primary" 
              onClick={handleSubmit}
              disabled={!isFormChanged}
            >
              Zapisz zmiany
            </Button>
          </Form.Item>
        </Form>
      </Card>
    );
  };

  export default Limits;